export const API_BASE_URL = 'https://ja-signage.azurefd.net';

export const AZURE_CDN = {
  ENDPOINT: 'https://cdn-endpoint-jasignage.azureedge.net/jasignage-prod/',
  SAS: '?sp=r&st=2023-04-03T07:15:14Z&se=9999-04-03T15:15:14Z&spr=https&sv=2021-12-02&sr=c&sig=qK9P6y6J66Y%2ByxqQ3ZkOiFUdYXxBNt1Y8gX1l9%2B46uI%3D',
  CONNECTSTRING:
    'BlobEndpoint=https://jasignage.blob.core.windows.net/;QueueEndpoint=https://jasignage.queue.core.windows.net/;FileEndpoint=https://jasignage.file.core.windows.net/;TableEndpoint=https://jasignage.table.core.windows.net/;SharedAccessSignature=sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2099-11-07T13:31:00Z&st=2024-11-07T05:31:00Z&spr=https&sig=RRiHeEJ1cFgUlXj%2BLAgrfdoH9L5jbkmgRbkaAENl%2FuU%3D',
  CONTAINERNAME: 'jasignage-prod',
};

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDC7SmSJ4Tw-3QOrz_lIKTC08m0JHYBfxQ',
  authDomain: 'ja-signage.firebaseapp.com',
  projectId: 'ja-signage',
  storageBucket: 'ja-signage.appspot.com',
  messagingSenderId: '988303681755',
  appId: '1:988303681755:web:ef762b82239c7440f844fe',
};

export const VAP_ID =
  'BGFo8PhkBYySYWAuL8W_tsmkipVa0i7Dcxv3vpn-xDUPiBeLSBlr8z3XtdvgSVXzkXDOuuzmUPfD8R1-Sya4y4s';
